import React from "react";
import { SymbolRunProps } from "../types";

export const SymbolRun: React.FC<SymbolRunProps> = (props) => {
  return React.createElement("RDSymbolRun", props);
};
